export default __webpack_public_path__ + "static/media/codespring.7f67afc2.jpg";